export default "__VITE_ASSET__BBBAIURZ__"